import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { RefundLoyaltyPointsRequest } from "../../admin/loyalty/loyaltyApi";
import { refundPoints } from "../../admin/loyalty/loyaltyApi";
import { adminLoyaltyPointsKey } from "./useAdminLoyaltyPoints";

export const useRefundLoyaltyPoints = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const refundLoyaltyPointsMutation = useMutation<void, unknown, RefundLoyaltyPointsRequest>({
    mutationFn: (v) => refundPoints(v),
    onSuccess: async () => {
      enqueueSnackbar(`Punkty zostały zrefundowane.`, { variant: "success" });
      // invalidate every entry whose key begins with the base adminLoyaltyPointsKey
      await queryClient.invalidateQueries({ queryKey: [adminLoyaltyPointsKey], exact: false });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się zrefundować punktów. Powód: ${(error as Error).message}`, { variant: "error" });
    },
  });

  return {
    refundLoyaltyPoints: (r: RefundLoyaltyPointsRequest) => refundLoyaltyPointsMutation.mutateAsync(r),
  };
};
